import { Injectable, inject } from '@angular/core';
import { DirtyCheckPlugin, Query } from '@datorama/akita';
import { FileDataModel, LOCompType } from '../../cmg-1003/models';

import { Cmg1003FileDataStore } from './file-data.store';
import { DirtyChecker2 } from '../core/dirty-checker-2';

@Injectable({ providedIn: 'root' })
export class Cmg1003FileDataQuery extends Query<FileDataModel> {
  protected store: Cmg1003FileDataStore;

  dirtyChecker2: DirtyChecker2 = new DirtyChecker2(this.store, this);
  occupancyTypeDirtyChecker = new DirtyCheckPlugin(this, { watchProperty: 'occupancyType' });

  constructor() {
    const store = inject(Cmg1003FileDataStore);

    super(store);

    this.store = store;
  }
  showAntiSteering$ = this.select((fileData) => {
    return fileData.isBusinessPurpose === false && fileData.loCompType !== LOCompType.BorrowerPaid;
  });
}
